import API from '../libraries/API';

/**
 * Subscribe to newsletter
 * @param {Object} params
 * @param {string} params.first_name 
 * @param {string} params.last_name
 * @param {string} params.email 
 * @param {boolean} params.receive_news
 */
const subscribeNewsletter = params => API.post('newsletter/subscribe', params);

export default {
  subscribeNewsletter,
};